module.exports = __webpack_public_path__ + "img/js-weird.0af2dfa7.png";